import Request from "../utilis/request";
import config from "../config";

export function getProduct(slug, params) {
    return Request({
        url: config.config.base_url+'/products/'+slug,
        method:'get',
        params: params
    })
}

export function getSmakeProduct(id, params = null) {
    return Request({
        url: config.config.base_url+'/api/smake/product/'+id,
        method:'get',
        params: params
    })
}

export function updateSmakeProduct(data) {
    return Request({
        url: config.config.base_url+'/api/smake/product',
        method:'post',
        data: data
    })
}
export function updateSmake(data){
    return Request({
        url: config.config.base_url+'/api/update/smake/product',
        method:'post',
        data: data
    })
}

export function updateSmakeProductPrintArea(data) {
    return Request({
        url: config.config.base_url+'/api/product/print',
        method:'post',
        data: data
    })
}

export function updateSmakeProductColorSwatch(data) {
    return Request({
        url: config.config.base_url+'/api/product/swatch',
        method:'post',
        data: data
    })
}

export function addRelatedProduct(data) {
    return Request({
        url: config.config.base_url+'/api/related/product',
        method:'post',
        data: data
    })
}
export function deleteRelatedProduct(data) {
    return Request({
        url: config.config.base_url+'/api/related/product',
        method:'delete',
        data: data
    })
}

export function companionProduct(data){
    return Request({
        url: config.config.base_url+'/api/companion/product',
        method:'post',
        data: data
    })
}

export function getAllProducts(params) {
    return Request({
        url: config.config.base_url+'/api/all/products',
        method:'get',
        params: params
    })
}

export function getAllWebsiteProducts(params) {
    return Request({
        url: config.config.base_url+'/api/all/website/products',
        method:'get',
        params: params
    })
}

export function updateProduct(product_id, data) {
    return Request({
        url: config.config.base_url+'/api/products/'+product_id+'/update',
        method:'post',
        data: data,
    })
}

export function updateVariants(id, data){
    return Request({
        url: config.config.base_url+'/api/products/'+id+'/variant',
        method:'post',
        data: data,
    })
}

export function getProducts(params) {
    return Request({
        url: config.config.base_url+'/products',
        method:'get',
        params: params,
    })
}
export function getProductsForCloning(params) {
    return Request({
        url: config.config.base_url+'/api/clone/products',
        method:'get',
        params: params,
    })
}
export function storeProduct(data) {
    return Request({
        url: config.config.base_url+'/api/products/create',
        method:'post',
        data: data,
    })
}

export function editUserProduct(id, data) {
    return Request({
        url: config.config.base_url+'/api/products/edit/'+id,
        method:'post',
        data: data,
    })
}
export function getAttributes(website_id) {
    return Request({
        url: config.config.base_url+'/api/attributes/'+website_id,
        method:'get',
    })
}
export function deleteProducts(ids) {
    return Request({
        url: config.config.base_url+'/api/products/delete',
        method:'post',
        data: {ids: ids},
    })
}

export function updateSortOrder(data) {
    return Request({
        url: config.config.base_url+'/api/products/update/sortorder',
        method:'post',
        data: data,
    })
}

export function addProductToCart(data) {
    return Request({
        url: config.config.base_url+'/api/products/add/to/cart',
        method:'post',
        data: data,
    })
}

export function deleteImage(data){
    return Request({
        url: config.config.base_url+'/api/products/delete/variant/image',
        method:'post',
        data: data,
    })
}

export function updateCustomFee(data){
    return Request({
        url: config.config.base_url+'/api/products/custom/fee',
        method:'post',
        data: data,
    })
}

export function exportSanMar(){
    return Request({
        url: config.config.base_url+'/api/used/sanmar',
        method:'post',
    })
}

export function exportProducts(){
    return Request({
        url: config.config.base_url+'/api/products/csv',
        method:'post',
    })
}

export function exportAllProducts(){
    return Request({
        url: config.config.base_url+'/api/all/products/csv',
        method:'post',
    })
}

export function changeVariantStatus(data){
    return Request({
        url: config.config.base_url+'/api/products/change/status',
        method:'post',
        data: data
    })
}
export function updateVariantCustomPhoto(data){
    return Request({
        url: config.config.base_url+'/api/custom/variant/photo',
        method:'post',
        data: data
    })
}
export function deleteCustomPhoto(data){
    return Request({
        url: config.config.base_url+'/api/delete/custom/variant/photo',
        method:'post',
        data: data
    })
}
export function changeIsFinishedStatus(data){
    return Request({
        url: config.config.base_url+'/api/is-finished/status',
        method:'post',
        data: data
    })
}
export function deleteWrongVariants(id){
    return Request({
        url: config.config.base_url+'/api/delete/variants/'+id,
        method:'post'
    })
}
export function updateCustomImages(id){
    return Request({
        url: config.config.base_url+'/api/update/custom/'+id,
        method:'post'
    })
}

export function deleteSmakeProduct(id){
    return Request({
        url: config.config.base_url+'/api/destroy/smake/'+id,
        method:'post'
    })
}

export function changeActiveStatus(id){
    return Request({
        url: config.config.base_url+'/api/smake/is-active/'+id,
        method:'post'
    })
}
export function updateKidsImages(data){
    return Request({
        url: config.config.base_url+'/admin/product-smake/update/kids/size/images',
        method:'post',
        data: data
    })
}
export function updateImages(data){
    return Request({
        url: config.config.base_url+'/admin/product-smake/update/size/images',
        method:'post',
        data: data
    })
}
export function updateColor(data){
    return Request({
        url: config.config.base_url+'/api/update/color',
        method:'post',
        data: data
    })
}
export function updateSanMarFromCSV(id){
    return Request({
        url: config.config.base_url+'/api/update/sanmar/from/csv/'+id,
        method:'post'
    })
}

export function deleteWholeColor(data){
    return Request({
        url: config.config.base_url+'/api/delete/color',
        method:'post',
        data: data
    })
}

export function getSmakeCategories(){
    return Request({
        url: config.config.base_url+'/api/smake/categories',
        method:'get',
    })
}

export function getSmakeInfo(){
    return Request({
        url: config.config.base_url+'/api/smake/details',
        method:'get',
    })
}

export function getProductsStatus(id){
    return Request({
        url: config.config.base_url+'/api/products/status/'+id,
        method:'get',
    })
}

export function changePublished(data){
    return Request({
        url: config.config.base_url+'/api/change/published',
        method:'post',
        data: data
    })
}

export function duplicateProduct(id){
    return Request({
        url: config.config.base_url+'/api/duplicate/product/'+id,
        method:'post'
    })
}

export function getProductsToFirstProduct(){
    return Request({
        url: config.config.base_url+'/api/products/grouped/category',
        method:'get',
    })
}

export function storePhotoUri(data) {
    return Request({
        url: config.config.base_url+'/products/create/photoUri',
        method:'post',
        data: data,
    })
}

export function validateUrl(data){
    return Request({
        url: config.config.base_url+'/api/validate/url',
        method:'post',
        data: data,
    })
}
export function changeActiveStatusSmakeProduct(id){
    return Request({
        url: config.config.base_url+'/api/smake/active/'+id,
        method:'post'
    })
}
export function trimImages(data){
    return Request({
        url: config.config.base_url+'/api/update/trim/images',
        method:'post',
        data
    })
}
